import React from 'react';
import { FadeIn, CTAButton } from './ui';
import { BookOpen, Headphones, Pill, Coffee, CheckCircle2 } from 'lucide-react';
export function Offer() {
  return <section className="py-24 px-4 bg-gradient-to-b from-brand-darker to-brand-dark relative border-y border-white/5" data-id="element-84">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-brand-orange/5 blur-[100px] pointer-events-none" data-id="element-85" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-86">
        <FadeIn data-id="element-87">
          <div className="text-center mb-16" data-id="element-88">
            <h2 className="font-bebas text-5xl md:text-7xl text-white mb-4" data-id="element-89">
              EL MÉTODO{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange to-brand-red" data-id="element-90">
                ENERGÍA IMPARABLE
              </span>
            </h2>
            <p className="text-xl text-zinc-400" data-id="element-91">
              Todo lo que necesitas para reprogramar tu cuerpo en 30 días.
            </p>
          </div>
        </FadeIn>

        <div className="bg-brand-card rounded-3xl border border-brand-orange/30 p-8 md:p-12 shadow-2xl shadow-brand-orange/10 mb-12" data-id="element-92">
          <div className="space-y-6 mb-12" data-id="element-93">
            <FadeIn delay={0.1} data-id="element-94">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-95">
                <BookOpen className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-96" />
                <div data-id="element-97">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-98">
                    Ebook Principal: El manual paso a paso de Biohacking Latino
                  </h4>
                  <p className="text-brand-orange font-mono text-sm" data-id="element-99">
                    Valor: $147
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-100">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-101">
                <Coffee className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-102" />
                <div data-id="element-103">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-104">
                    <span className="text-brand-orange" data-id="element-105">Bonus #1:</span> Guía
                    "Cafecito Estratégico"
                  </h4>
                  <p className="text-brand-orange font-mono text-sm" data-id="element-106">
                    Valor: $47
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-107">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-108">
                <Headphones className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-109" />
                <div data-id="element-110">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-111">
                    <span className="text-brand-orange" data-id="element-112">Bonus #2:</span> Audio
                    "Sueño Profundo en 5 min"
                  </h4>
                  <p className="text-brand-orange font-mono text-sm" data-id="element-113">
                    Valor: $37
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-114">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-115">
                <Pill className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-116" />
                <div data-id="element-117">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-118">
                    <span className="text-brand-orange" data-id="element-119">Bonus #3:</span> Manual
                    "Suplementos de Walmart que Sí sirven"
                  </h4>
                  <p className="text-brand-orange font-mono text-sm" data-id="element-120">
                    Valor: $27
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.5} data-id="element-121">
            <div className="border-t border-white/10 pt-8 text-center" data-id="element-122">
              <p className="text-zinc-400 text-lg line-through mb-2" data-id="element-123">
                VALOR TOTAL: $258.00
              </p>
              <p className="text-zinc-300 mb-6 max-w-2xl mx-auto" data-id="element-124">
                No vas a pagar $258. Ni siquiera vas a pagar los $97 que cobran
                los gurús americanos. Porque sé lo que cuesta ganar cada dólar
                en este país...
              </p>
              <div className="mb-8" data-id="element-125">
                <p className="text-brand-gold font-bold uppercase tracking-widest text-sm mb-2" data-id="element-126">
                  Tu Precio Hoy
                </p>
                <div className="font-bebas text-7xl md:text-8xl text-white drop-shadow-lg flex items-center justify-center gap-2" data-id="element-127">
                  <span className="text-4xl md:text-5xl text-brand-orange" data-id="element-128">
                    $
                  </span>
                  27
                </div>
                <p className="text-zinc-500 text-sm mt-2" data-id="element-129">
                  (Menos de lo que cuesta una cena en un fast food para dos
                  personas)
                </p>
              </div>

              <CTAButton className="w-full md:w-auto text-xl md:text-2xl py-5" data-id="element-130" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}